import React from "react";
import { Box, Typography } from "@material-ui/core";
import {SentimentVeryDissatisfiedRounded as ErrorFace} from '@material-ui/icons'
export default function NotFound() {
  return (
    <Box
      height="100vh"
      width="100%"
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexDirection='column'
      bgcolor='#0f0f0f'
      color='white'
      p={2}
    >
        <ErrorFace style={{fontSize:'100px',color:'#f50057',marginBottom:'30px'}}/>
        <Typography style={{color:'#f50057'}} variant='h3'>Error 404</Typography>
        <Typography style={{color:'#f50057',marginBottom:'30px'}} align='center' variant='h3'>Page Not Found</Typography>
        <Typography align='center' variant='h5'>Please check the URL for mistakes and try again.</Typography>


    </Box>
  );
}
